<template>
  <div
    class="formatted-text"
    v-html="field.properties.basic.text"
  />
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  field: {
    type: Object,
    required: true
  },
  values: {
    type: Object,
    required: true
  },
  errors: {
    type: Object,
    required: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  return {};
};
export default __sfc_main;
</script>

<style lang="scss">
.formatted-text {
  strong {
    color: inherit;
  }
}
</style>
